import React from "react";
import { mdiShieldAlertOutline, mdiCogOutline } from "@mdi/js";
import { SAMPLE_REPORT_URL } from "../../constants/global-constants";
import HowItWorksModal from "../../components/common/HowItWorksModal";

const FEATURES = [
  {
    icon: mdiShieldAlertOutline,
    title: "Content Appears in Reports",
    description: (
      <>
        The content you edit here will appear in the{" "}
        <strong>&apos;Inspection Scope &amp; Disclaimer&apos;</strong> section
        of all future reports you compile.{" "}
        <a
          href={SAMPLE_REPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary"
          style={{ textDecoration: "underline" }}
        >
          See sample report
        </a>
      </>
    ),
  },
  {
    icon: mdiCogOutline,
    title: "Hide or Show",
    description:
      "You can choose to show or hide this section for all future reports.",
  },
];

const DisclaimerHowItWorksModal = ({ show, onHide }) => (
  <HowItWorksModal
    show={show}
    onHide={onHide}
    title="How Disclaimer Setting Works"
    features={FEATURES}
  />
);

export default DisclaimerHowItWorksModal;
